module.exports = __webpack_public_path__ + "static/media/Heart.fc33d64a.svg";